define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, UserContext) {
    "use strict";
    var AdminConsole = /** @class */ (function () {
        function AdminConsole() {
        }
        AdminConsole.prototype.init = function () {
            var self = this;
            var expandContentDivs = function (divs) {
                divs.height(window.innerHeight - 320);
            };
            var tabStripElement = $("#tabstrip").kendoTabStrip({
                animation: {
                    open: {
                        effects: "fadeIn"
                    }
                }
            });
            var resizeAll = function () {
                expandContentDivs(tabStripElement.children(".k-content"));
            };
            resizeAll();
            $(window).resize(function () {
                resizeAll();
            });
            var getModelCall = tools.ajaxGet({
                url: "/AdminConsole/GetActionsList",
                success: function (data) {
                    if (data.Success) {
                        self.actionsList = data.Data;
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
            var getLookupCall = tools.ajaxGet({
                url: "/AdminConsole/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
            $.when(getModelCall, getLookupCall).done(function (data) {
                ko.applyBindings(self, document.getElementById("ko-main-content"));
                self.initActionLogs();
                self.initActions();
                $("#contextLoader").hide();
                $("#mainContext").show();
            });
        };
        AdminConsole.prototype.initActionLogs = function () {
            var self = this;
            var gridId = "recurring-profiles-log-table";
            var gridStructure = self.lookupLists.GridStructures.ActionLogsStructure;
            var columns = gridStructure.columns;
            if (UserContext.hasAccess("Admin")) {
                var actionsColumn = {
                    field: "",
                    width: "100px",
                    template: function (dataItem) {
                        var html = "";
                        var today = new Date();
                        if (true /*dataItem.CalcDate > today*/) {
                            html += '<a class="btn btn-sm btn-warning btn-recalc" title="Recalculate" href="#"><i class="glyphicon glyphicon-repeat"></i></a>';
                            html += '&nbsp;<a class="btn btn-sm btn-danger btn-delete" title="Delete Calculations" href="#"><i class="fa fa-trash-o"></i></a>';
                        }
                        return html;
                    }
                };
                columns.push(actionsColumn);
            }
            self.actionLogsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/AdminConsole/GetActionLogs",
                            type: "POST",
                            data: function () {
                                var data = {};
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    columns: columns,
                    resizable: true,
                    detailInit: self.initRecurrings.bind(self)
                },
                enableExport: {
                    entityName: "ActionLog",
                    title: "Action Logs",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: gridId,
                showPagerOnTop: false
            };
            self.actionLogsTable.initGrid(gridOptions);
            $("#recurring-profiles-log-table tbody").on("click", ".btn-recalc", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                tools.confirmModal({
                    title: "Recalculate Recurring Invoices?",
                    text: "Are you sure you want to recalculate recurring invoices?",
                    buttonTitle: "Recalculate",
                    type: "warning",
                    modalOptions: {}
                }, function (modal) {
                    $(modal).modal('hide');
                    tools.ajaxPost({
                        url: "/AdminActions/RecalculateRecurring",
                        data: {
                            key: dataItem.Key
                        },
                        success: function (result) {
                            if (result.Success) {
                                tools.success(JSON.stringify(result));
                            }
                            else {
                                tools.error(result.Error);
                            }
                            self.actionLogsTable.refresh();
                        }
                    });
                });
                event.preventDefault();
            }).on("click", ".btn-delete", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                tools.confirmModal({
                    title: "Delete Recurring Invoices?",
                    text: "Are you sure you want to delete recurring invoices calculated items?",
                    buttonTitle: "Delete",
                    type: "danger",
                    modalOptions: {}
                }, function (modal) {
                    $(modal).modal('hide');
                    tools.ajaxPost({
                        url: "/AdminActions/DeleteRecurringAction",
                        data: {
                            key: dataItem.Key
                        },
                        success: function (result) {
                            if (result.Success) {
                                tools.success(JSON.stringify(result));
                            }
                            else {
                                tools.error(result.Error);
                            }
                            self.actionLogsTable.refresh();
                        }
                    });
                });
                event.preventDefault();
            });
        };
        AdminConsole.prototype.initRecurrings = function (e) {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.RecurringStructure;
            var grid = $("<div/>").appendTo(e.detailCell).kendoGrid({
                dataSource: {
                    transport: {
                        read: {
                            url: "/AdminConsole/GetActionLogRecurrings",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.key = e.data.Key;
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverPaging: false,
                    serverSorting: false,
                    serverFiltering: false,
                    pageSize: 100,
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                },
                scrollable: false,
                resizable: true,
                sortable: true,
                pageable: true,
                columns: gridStructure.columns,
                dataBound: function (event) {
                }
            }).data("kendoGrid");
        };
        AdminConsole.prototype.initActions = function () {
            var self = this;
            $("#actionsTable .btn-run").on("click", function () {
                var row = $(this).closest("tr");
                var id = row.data("id");
                if (id) {
                    var action = ko.utils.arrayFirst(self.actionsList, function (item) {
                        return item.Id == id;
                    });
                    if (action) {
                        if (action.ActionMethod === "GET") {
                            self.getAction(action);
                        }
                        else if (action.ActionMethod === "POST") {
                            self.postAction(action);
                        }
                        else {
                            tools.error("Unknown action method");
                        }
                    }
                    else {
                        tools.error("Unable to find action");
                    }
                }
                else {
                    tools.error("Unable to find action id");
                }
            });
        };
        AdminConsole.prototype.getAction = function (action, data) {
            tools.ajaxGet({
                url: action.ActionUrl,
                data: data,
                success: function (result) {
                    if (result.Success) {
                        tools.success(JSON.stringify(result));
                    }
                    else {
                        tools.error(result.Error);
                    }
                }
            });
        };
        AdminConsole.prototype.postAction = function (action, data) {
            tools.ajaxPost({
                url: action.ActionUrl,
                data: data,
                success: function (result) {
                    if (result.Success) {
                        tools.success(JSON.stringify(result));
                    }
                    else {
                        tools.error(result.Error);
                    }
                }
            });
        };
        return AdminConsole;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/AdminConsole/Index")) {
            log.log("Initialize Admin console page");
            $(function () {
                (new AdminConsole()).init();
            });
        }
    }, 0);
    return AdminConsole;
});
//# sourceMappingURL=adminConsole.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/adminConsole/adminConsole.js
// module id = 269
// module chunks = 2